import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down\">\n<rect x=\"18.3145\" y=\"10.6562\" width=\"8\" height=\"1\" transform=\"rotate(135 18.3145 10.6562)\" fill=\"#737373\" />\n<rect x=\"7.70703\" y=\"9.94922\" width=\"8\" height=\"1\" transform=\"rotate(45 7.70703 9.94922)\" fill=\"#737373\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol